import React, { useState, useId } from "react";

type CustomTooltipProps = {
  children: React.ReactNode;
};

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipId = useId();

  return (
    <span className="custom-tooltip-wrapper">
      <button
        type="button"
        className="geico-icon--xsmall icon-help-button custom-tooltip-icon"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
        aria-label="More information"
        aria-describedby={tooltipId}
        aria-expanded={isVisible}
      />
      {isVisible && (
        <span id={tooltipId} className="custom-tooltip-content" role="tooltip">
          {children}
        </span>
      )}
    </span>
  );
};
